module.exports = __webpack_public_path__ + "static/media/icon-error.d3f1db3a.svg";